/* unplugin-vue-components disabled */import { render } from "./showXRatedConfirmation.vue?vue&type=template&id=13dbb395&scoped=true"
import script from "./showXRatedConfirmation.vue?vue&type=script&lang=js"
export * from "./showXRatedConfirmation.vue?vue&type=script&lang=js"

import "./showXRatedConfirmation.vue?vue&type=style&index=0&id=13dbb395&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dbb395"]])

export default __exports__